import moment from 'moment';
import { Button, Segment } from 'semantic-ui-react';
import { CerrarPopup, MostrarPopup } from '../Reducers/PopupReducer';
import ReactPDF, { pdf, PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';

export const ServerUri = () => {
    //return "https://ross-bitso-backend.herokuapp.com/";
    return `http://${window.location.hostname}:3002/`
}
export const GetNewGuid = () => {
    return Math.floor(Math.random() * Date.now());
}
export const Base64Encode = (data) => {
    return btoa(unescape(encodeURIComponent(data)));
}
export const Base64Decode = (data) => {
    return decodeURIComponent(escape(window.atob(data)));
}
export const Sleep = async (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export const DiasXMes = (anio, mes) => {
    return new Date(anio, mes, 0).getDate();
}
export const replaceAll = (string, search, replace) => {
    return string.split(search).join(replace);
}
export const ObtenerValorPropiedad = (item, property) => {
    try {
        if (property.indexOf('.') !== -1) {
            const valores = property.split('.');
            let ultimoValor = { ...item };
            valores.map((val) => {
                ultimoValor = ObtenerValorPropiedad(ultimoValor, val);
                return val;
            });
            return ultimoValor;
        } else {
            return item[property];
        }
    } catch (err) {
        return "";
    }
}
export const AsignarValorPropiedad = (item, property, value) => {
    try {
        if (property.indexOf('.') !== -1) {
            const valores = property.split('.');
            let ultimaPropiedad = "";
            let i = 1;
            let ultimoValor = { ...item };
            valores.map((val) => {
                ultimoValor = ObtenerValorPropiedad(ultimoValor, val);
                if (i === valores.length) {
                    item[ultimaPropiedad] = {
                        [val]: value
                    };
                } else {
                    if (ultimoValor === "" || ultimoValor === undefined) {
                        item[val] = {};
                    }
                }
                i++;
                ultimaPropiedad = val;
            });
            return ultimoValor;
        } else {
            return item[property] = value;
        }
    } catch (err) {
        return "";
    }
}
export const clearObject = (obj) => {
    if (!obj) return obj;
    let objClon = { ...obj };
    for (let index in objClon) {
        objClon[index] = '';
    }
    return objClon;
}
export const formatDecimal = (val, decimals = 2) => {
    try {
        if (val) {
            if (val === 0) {
                return "0.00";
            }
            val = parseFloat(val);
            return val.toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
        return "";
    } catch (err) {
        return "";
    }
}
export const iniciarLecturaSocket = (sessionid, onMessageReceived) => {
    var socket = setInterval(() => {
        const uri = `${ServerUri()}ws.ashx?sessionid=${sessionid}`;
        fetch(uri)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (onMessageReceived) {
                    onMessageReceived(data)
                }
            });

    }, 1000);
    return socket;
}
export const detenerSocket = (socket) => {
    clearInterval(socket);
}
export const esTeclaNavegacion = (tecla) => {
    const teclas = ['Tab', 'Enter'];
    return teclas.includes(tecla);
}
export const ConvertToBool = (strBool) => {
    return (strBool === "true" || strBool === "True")
}
export const ConvertToInt = (strInt) => {
    return (strInt + 0)
}
export const ConvertToDecimal = (strDec) => {
    return (strDec + 0.00)
}
export const EVAL = (result) => {
    let _entidad = eval("(" + result + ")");
    _entidad = CheckDateEntity(_entidad);
    return _entidad;
}
export const ToJson = (entity) => {
    let newEntity = CheckDateEntity(entity, 2)
    const _json = JSON.stringify(newEntity)
    return _json;
}
export const CheckDateEntity = (entity, tipo = 1) => {
    if (Array.isArray(entity)) {
        for (var item in entity) { CheckDateEntity(entity[item], tipo); }
    } else {
        for (var i in entity) {
            //if(_entidad.hasOwnProperty(i))
            if (entity[i]) {
                // if(moment(entity[i]).isValid()){
                //     entity[i] = moment(entity[i]).toDate();
                // }
                if (entity[i].getTime && tipo === 2) {
                    entity[i] = DateToString(entity[i]);
                }
                if (entity[i].includes && tipo === 1) {
                    // if (entity[i].includes("/Date(")) { entity[i] = StringToDate(entity[i]) }
                    if (
                        entity[i].includes("-") &&
                        entity[i].includes("T") &&
                        entity[i].includes(":") &&
                        entity[i].includes("Z")
                    ) { entity[i] = StringToDate(entity[i]); }
                }
                if (entity[i].Id || entity[i].InfoFormatoReporte) { entity[i] = CheckDateEntity(entity[i], tipo); }
                if (Array.isArray(entity[i])) {
                    for (var item in entity[i]) { CheckDateEntity(entity[i], tipo); }
                }
            }
        }

    }
    return entity;
}
// const StringToDate = (text) => {
//     const _str = text.replace("/Date(", "").replace(")/", "");
//     let md = moment(+_str).utc()
//     let nd = new Date(md.year(), md.month(), md.date(), md.hour(), md.minute(), md.second(), md.millisecond())
//     return new Date(nd)
// }
const StringToDate = (text) => {
    let md = moment(text).utc()
    let nd = new Date(md.year(), md.month(), md.date(), md.hour(), md.minute(), md.second(), md.millisecond())
    return new Date(nd)
}

const DateToString = (fecha) => {
    let dUTC = moment(fecha).zone(moment(fecha).zone() * 2)
    let nd = new Date(dUTC.year(), dUTC.month(), dUTC.date(), dUTC.hour(), dUTC.minute(), dUTC.second(), dUTC.millisecond());
    return "/Date(" + nd.getTime() + ")/";
}
export const LeerArchivoTXT = (archivo, callback) => {
    var reader = new FileReader();
    reader.onload = function (event) {
        if (callback) { callback(event.target.result) }
    };
    reader.readAsText(archivo, "ISO-8859-1");
}
export const ObtenerItemCombo = (id, clave, nombre) => {
    return { value: id, key: clave, text: nombre }
}
export const AbrirReporte = (dispatch, reporte, nombre) => {
    dispatch(MostrarPopup({
        Titulo: `Imprimir ${nombre}`,
        Content: (
            <>
                <PDFViewer style={{ width: "100%", height: "500px" }}>
                    {reporte}
                </PDFViewer>
                <PDFDownloadLink document={reporte} fileName={`${nombre}.pdf`}>
                    {({ blob, url, loading, error }) => (`${nombre}.pdf`)}
                </PDFDownloadLink>
                <Segment basic textAlign="right">
                    <Button onClick={() => { dispatch(CerrarPopup()) }} negative>Cerrar</Button>
                </Segment>
            </>
        ),
        Cerrar: (r) => { }
    }))
}